import React from "react";
import DashboardDataTag from "./DashboardDataTag";
import DataTagLayout from "./DataTagLayout";
import DataEstate from "./DataEstate/DataEstate";
import DataTagReports from "./DataTagReports";
import DataEstateSummaryTab from "./DataEstateSummaryTab/DataestatesummaryTab";

function DataGuardHomePage() {
  const tabs = [
    {
      name: "Enterprise Dashboard",
      component: <DashboardDataTag />,
    },
    {
      name: "Data Estate",
      component: <DataEstate />,
    },
    { name: "Executive Summary", component: <DataEstateSummaryTab /> },
    {
      name: "Reports",
      component: <DataTagReports />,
    },
  ];
  return (
    <div>
      <DataTagLayout tabs={tabs} />
    </div>
  );
}

export default DataGuardHomePage;
